import axios from "../../axios";
import { devUrl } from "../../settings";

const state = {
  users: [],
  usersQuantity: null,
  usersForSelect: null,
  usersDeletionId: null,
  s3CredentialsSet: false
};

const getters = {
  users(state) {
    return state.users;
  },
  getUsersQuantity(state) {
    return state.usersQuantity;
  },
  getUsersDeletingId(state) {
    return state.usersDeletionId;
  },
  getUSersForSelect(state) {
    return state.usersForSelect;
  }
};

const mutations = {
  storeUsers(state, payload) {
    state.users = payload.results;
    state.usersQuantity = payload.usersCount;
    state.usersForSelect = payload.usersForSelect;
  },
  storeUserModalId(state, payload) {
    state.usersDeletionId = payload;
  },
  setS3CredentialsSet(state) {
    state.s3CredentialsSet = true;
  }
};

const actions = {
  async fetchUsers({ commit }, page) {
    let res = await axios.get(`/users/?limit=5&offset=${5 * page - 5}`);

    const usersForSelect = [];

    res.data.results.forEach(item => {
      let studyObj = {
        id: item.id,
        name: item.name
      };

      usersForSelect.push(studyObj);
    });

    commit("storeUsers", {
      results: res.data.results,
      usersCount: res.data.count,
      usersForSelect
    });
  },
  postUser({ dispatch }, formData) {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    console.log(formData);

    return axios
      .post("/users/", formData, config)
      .then(() => {
        dispatch("fetchUsers", 1);
      })
      .catch(err => console.log(err));
  },
  sendUserIdToModal({ commit }, id) {
    commit("storeUserModalId", id);
  },
  deleteUser({ dispatch }) {
    const token = localStorage.getItem("token");
    const id = state.usersDeletionId;

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    axios
      .delete(`${devUrl}users/${id}`, config)
      .then(() => {
        dispatch("fetchUsers", 1);
        dispatch("sendUserIdToModal", null);
      })
      .catch(err => console.log(err));
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
